import { memo, useMemo } from "react";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setBilledOperationSummariesSortColumn } from "@sso/store/slices/billedOperations";
import { TableColumn } from "@sso/types";
import { Table, TableWrapper, TD, TH } from "@sso/ui/Table";

import { BilledOperationOrganisationSummary, BilledOperationOrganisationSummaryKeys } from "../../types/billedOperationOrganisationSummary";

interface BilledOperationOrganisationSummyTableProps {
  summaryList: BilledOperationOrganisationSummary[];
  columns: TableColumn<BilledOperationOrganisationSummaryKeys>[];
}

export const BilledOperationOrganisationSummaryTable = memo(({ summaryList, columns }: BilledOperationOrganisationSummyTableProps) => {
  const dispatch = useAppDispatch();

  const data: BilledOperationOrganisationSummary[] = useMemo(
    () => summaryList.map(item => ({
      ...item,
      currentMonthToDateTotal: `£${Number(item[BilledOperationOrganisationSummaryKeys.CURRENT_MONTH_TO_DATE_TOTAL]).toFixed(2)}`,
      lastMonthTotal: `£${(Number(item[BilledOperationOrganisationSummaryKeys.LAST_MONTH_TOTAL])).toFixed(2)}`,
    })), [summaryList]);

  const handleSortAction = (column: string) => {
    dispatch(setBilledOperationSummariesSortColumn(column));
  };

  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            {columns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(summary => (
            <tr key={summary[BilledOperationOrganisationSummaryKeys.ORGANISATION_ID]} id={summary[BilledOperationOrganisationSummaryKeys.ORGANISATION_ID].toString()}>
              {columns.map(col => (
                <TD key={col.field} id={col.field}>
                  {summary[col.field]}
                </TD>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  );
});
